import { type PeriodOption, PeriodTypeEnum } from './types';

export const periodOptions: PeriodOption[] = [
    {
        label: __('无'),
        value: PeriodTypeEnum.NONE,
        nextDepositTime: null
    },
    {
        label: __('每天一次'),
        value: PeriodTypeEnum.DAY,
        nextDepositTime: {
            num: 1,
            type: 'd'
        }
    },
    {
        label: __('每周一次'),
        value: PeriodTypeEnum.WEEK,
        nextDepositTime: {
            num: 1,
            type: 'w'
        }
    },
    {
        label: __('每两周一次'),
        value: PeriodTypeEnum.WEEK2,
        nextDepositTime: {
            num: 2,
            type: 'w'
        }
    },
    {
        label: __('每月一次'),
        value: PeriodTypeEnum.MONTH,
        nextDepositTime: {
            num: 1,
            type: 'M'
        }
    }
];
